export default __webpack_public_path__ + "static/media/cripto-com.3cdf1229.jpeg";